function ZzyDate () {
  this.unixtimestamp = function (string_time) {
    return Date.parse(new Date(string_time)) / 1000
  }
  this.timestamp = function () {
    return Date.parse(new Date())
  }
  this.addZeroPrefix = function (val) { // date obj
    if (val < 10) {
      val = '0' + val
    }
    return val
  }
  this.format = function (timestamp) {
    var d = new Date(timestamp * 1000)
    return d.getFullYear() + '-' +
         this.addZeroPrefix(d.getMonth() + 1) + '-' +
         this.addZeroPrefix(d.getDate()) + ' ' +
         this.addZeroPrefix(d.getHours()) + ':' +
         this.addZeroPrefix(d.getMinutes()) + ':' +
         this.addZeroPrefix(d.getSeconds())
  }

  this.format2 = function (timestamp) {
    var d = new Date(timestamp * 1000)
    return d.getFullYear() + '-' +
         this.addZeroPrefix(d.getMonth() + 1) + '-' +
         this.addZeroPrefix(d.getDate())
  }

  this.getCurrentTime = function () {
    var d = new Date()
    return d.getFullYear() + '-' +
       this.addZeroPrefix(d.getMonth() + 1) + '-' +
       this.addZeroPrefix(d.getDate()) + ' ' +
       this.addZeroPrefix(d.getHours()) + ':' +
       this.addZeroPrefix(d.getMinutes()) + ':' +
       this.addZeroPrefix(d.getSeconds())
  }
  this.getCurrentDate = function () {
    var d = new Date()
    return d.getFullYear() + '-' +
       this.addZeroPrefix(d.getMonth() + 1) + '-' +
       this.addZeroPrefix(d.getDate())
  }
  this.dateFtt = function (fmt, date) { /* 时间格式化处理 */
    if (!date) date = new Date()
    var o = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds(), // 秒
      'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      'S': date.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length)) }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) { fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
    }
    return fmt
  }
  this.friendly = function (result = 0) {
    if (typeof (result) !== 'number') {
      return '-'
    }
    result = parseInt(result)
    let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600)
    let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60))
    let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60))

    let res = ''
    if (h !== '00') res += `${h}小时`
    if (m !== '00') res += `${m}分钟`
    res += `${s}秒`
    return res
  }
  this.getLastMonthYestdy = function (num = 1) {
    var one = 86400000 * num
    var nS = Date.parse(new Date()) - one
    return new Date(parseInt(nS)).toLocaleDateString().replace(/\//g, '-')
  }
}
let zzyDate = new ZzyDate()

export default zzyDate



// WEBPACK FOOTER //
// ./src/components/utils/datetime.js